import changeLevel from '../services/changeLevel';

const startaStage = () => {
	const btnsStart = document.querySelectorAll('.button');
	// wrapperTutle =  document.querySelector('.wrapperTutle'),
	// buttonHolder =document.querySelector('.buttonHolder'),
	// body = document.body,
	// html = document.documentElement;

	let selectorListQ = [];
	btnsStart.forEach(item => {
		item.addEventListener('click', e => {
			e.preventDefault();
			selectorListQ = [];
			// console.log(e);
			changeLevel(e.target);
			// changeLevel(e.target, selectorListQ, btnsStart);
		});
	});
};
export default startaStage;
